export default "__VITE_ASSET__DKapOLr$__"